import React from "react";
function OpenAccount() {
    return ( 
        <div className='container border-bottom p-5'>
            <div className='row'>
                <h1 className='mt-3'>
                    Open a Zerodha account
                </h1>
                <p>
                   Modern platforms and apps,&#8377; investments,and flat &#8377;20 interday and F&O trades.
                </p>
                <button className='mt-3 p-2 mb-5 fs-5 btn btn-primary' style={{width:'30%',margin:"0 auto "}}>Signup Now</button>
            </div>
        </div>
      );
}

export default OpenAccount;